import { ServerClient } from 'common/utils/http/http-clients';
import { IDailyActivityReportRead } from './daily-activity-report.types';
import { IResponseList } from 'common/models/response-list.interface';

class DailyActivityReportService {
  async getReports(
    pageLimit: any,
    filter: string | null | undefined,
    sort: string | null | undefined,
    search: string | null | undefined = '',
  ): Promise<IResponseList<IDailyActivityReportRead>> {
    const res = await ServerClient.get<IResponseList<IDailyActivityReportRead>>('/daily-activity-reports', {
      params: {
        filter,
        ...pageLimit,
        sort,
        search,
      },
    });
    return res?.data;
  }

  async create(dispatcher: string, entryDetails: string) {
    const res = await ServerClient.post<IDailyActivityReportRead>('/daily-activity-reports', {
      dispatcher: dispatcher,
      entryDetails: entryDetails,
    });

    return res?.data;
  }

  async delete(id: number) {
    const res = await ServerClient.delete(`/daily-activity-reports/${id}`);
    return res?.data;
  }
}

export const dailyActivityReportService = new DailyActivityReportService();
export default dailyActivityReportService;
